import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { ResetPasswordForm } from "@/features/auth/ResetPasswordForm";

export const Route = createFileRoute("/reset-password")({
  component: ResetPasswordPage,
  validateSearch: (search: Record<string, unknown>): { token?: string } => ({
    token: typeof search.token === "string" && search.token ? search.token : undefined,
  }),
});

function ResetPasswordPage() {
  const { token } = Route.useSearch();
  const navigate = Route.useNavigate();
  // Capture the one-time token, then scrub it from the address bar so it
  // does not linger in window.location or browser history. The captured value
  // is re-synced whenever a token appears in search so an in-place navigation
  // to this route with a new token still reaches the form after the scrub.
  const [capturedToken, setCapturedToken] = useState(token);

  useEffect(() => {
    if (token) {
      setCapturedToken(token);
      void navigate({ search: {}, replace: true });
    }
  }, [token, navigate]);

  return (
    <div className="bg-arc-gray-50 flex min-h-screen items-center justify-center px-4 py-16">
      <ResetPasswordForm token={capturedToken} />
    </div>
  );
}
